"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _translations = require("../../libs/translationsUtils/translations");

var items = {
  tableOfContentsOption: {
    label: (0, _translations.t)('Forum', 'editor.table_of_contents.menu_option'),
    // @ts-expect-error
    iconLabel: 'Table of contents',
    group: 'more_tools_group',
    command: 'table-of-contents',
    icon: 'bookmark-anchor',
    order: 0
  },
  mediaOption: {
    label: (0, _translations.t)('Forum', 'wysiwyg.embed.btn.title'),
    // @ts-expect-error
    iconLabel: 'Insert Media Embed',
    group: 'more_tools_group',
    command: 'embed',
    icon: 'video',
    order: 1
  },
  tableOption: {
    label: (0, _translations.t)('Common', 'editor.table'),
    // @ts-expect-error
    iconLabel: 'Table',
    group: 'more_tools_group',
    command: 'table',
    icon: 'table',
    order: 2
  },
  codeSnippetOption: {
    label: (0, _translations.t)('Forum', 'wysiwyg.code.btn.title'),
    // @ts-expect-error
    iconLabel: 'Insert Code Snippet',
    group: 'more_tools_group',
    command: 'codeSnippet',
    icon: 'code',
    order: 3
  },
  hrOption: {
    label: (0, _translations.t)('Common', 'editor.horizontal.line'),
    // @ts-expect-error
    iconLabel: 'Insert Horizontal Line',
    group: 'more_tools_group',
    command: 'horizontalrule',
    icon: 'hr',
    order: 4
  },
  spoilerOption: {
    label: (0, _translations.t)('Forum', 'wysiwyg.spoiler.btn.title'),
    // @ts-expect-error
    iconLabel: 'Spoiler',
    group: 'more_tools_group',
    command: 'spoiler',
    icon: 'spoiler',
    order: 5
  },
  pollOption: {
    label: (0, _translations.t)('Forum', 'wysiwyg.poll.btn.title'),
    // @ts-expect-error
    iconLabel: (0, _translations.t)('Forum', 'wysiwyg.poll.btn.title'),
    group: 'more_tools_group',
    command: 'poll',
    icon: 'poll',
    order: 6
  }
};
var _default = items;
exports.default = _default;